import { render, staticRenderFns } from "./columnDataFilter.vue?vue&type=template&id=1af89d6e&"
import script from "./columnDataFilter.vue?vue&type=script&lang=js&"
export * from "./columnDataFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/columnDataFilter.vue"
export default component.exports